import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "./activityApi";

export const fetchActivity = createAsyncThunk("activity/fetchActivity", async (params, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getActivity(params, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch activity");
  }
});

export const fetchMyActivity = createAsyncThunk("activity/fetchMyActivity", async (params, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getMyActivity(params, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch activity");
  }
});

export const fetchResourceHistory = createAsyncThunk("activity/fetchResourceHistory", async ({ type, id }, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getResourceHistory(type, id, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch history");
  }
});

const activitySlice = createSlice({
  name: "activity",
  initialState: { activities: [], total: 0, page: 1, pages: 0, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    const setLoading = (state) => { state.loading = true; state.error = null; };
    const setError   = (state, action) => { state.loading = false; state.error = action.payload; };
    const setData    = (state, action) => {
      state.loading = false;
      const payload = action.payload || {};
      state.activities = payload.activities || payload || [];
      state.total = payload.total || 0;
      state.page = payload.page || 1;
      state.pages = payload.pages || 0;
    };

    builder
      .addCase(fetchActivity.pending, setLoading)
      .addCase(fetchActivity.fulfilled, setData)
      .addCase(fetchActivity.rejected, setError)
      .addCase(fetchMyActivity.pending, setLoading)
      .addCase(fetchMyActivity.fulfilled, setData)
      .addCase(fetchMyActivity.rejected, setError)
      .addCase(fetchResourceHistory.pending, setLoading)
      .addCase(fetchResourceHistory.fulfilled, setData)
      .addCase(fetchResourceHistory.rejected, setError);
  },
});

export default activitySlice.reducer;
